import { Footer } from '@denqfabrik/landing-ui';
import { useTranslation } from '../../i18n';

export default function AppFooter() {
  const { lang, t } = useTranslation();

  const links =
    lang === 'en'
      ? [
          { label: t.footer.impressum, href: '/en/imprint' },
          { label: t.footer.datenschutz, href: '/en/privacy' },
          {
            label: t.footer.linkedin,
            href: 'https://www.linkedin.com/company/denqfabrik',
            external: true,
          },
          { label: t.footer.github, href: 'https://github.com/denqfabrik', external: true },
        ]
      : [
          { label: t.footer.impressum, href: '/de/impressum' },
          { label: t.footer.datenschutz, href: '/de/datenschutz' },
          {
            label: t.footer.linkedin,
            href: 'https://www.linkedin.com/company/denqfabrik',
            external: true,
          },
          { label: t.footer.github, href: 'https://github.com/denqfabrik', external: true },
        ];

  return <Footer copyright={t.footer.copyright} links={links} />;
}
